import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button, Col, Dropdown, Row } from "react-bootstrap";
import RangeCredit from "../../Components/Game/Addons";
import {
  __,
  Event,
  forceSatoshiFormat,
  isValidNumber,
  wait,
  sendNotfication,
  playAudio,
} from "../../../Helper";
import { gameCoin } from "../../../actions/gameCoin";
import storage from "../../../Storage";
import { FiAlertCircle } from "react-icons/fi";
import { setWallet } from "../../../actions/gameWallet";
import C from "../../../Constant";

class Bet extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      engine: this.props.engine,
      isLogged: storage.getKey("logged") !== null ? true : false,
      amount: forceSatoshiFormat(
        storage.getKey("lam") ? storage.getKey("lam") : 50.00
      ),
      buttonText: "BET",
      type: 1,
      typeName: "DEFAULT",
      disabled: false,
      deal: false,
      cards: [],
      dealCards: [],
      winning: false,
      c: 0,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleBet = this.handleBet.bind(this);
  }

  componentDidMount() {
    let { engine } = this.state;
    this._isMounted = true;

    if (this._isMounted) {
      this.props.gameCoin();

      engine.on(C.PLAY_VIDEOPOKER, () => this.play());
      engine.on(C.BUSTED_VIDEOPOKER, () => this.busted());
      engine.on(C.ERROR_VIDEOPOKER, (data) => this.error(data));
      engine.on("card", (data) => this.setCards(data));
      engine.on("deal_card", (data) => this.setDealCards(data));
      engine.on("toggle_card_hold", (data) => this.toggleCard(data));
      engine.on("deal", (data) => this.deal(data));
      engine.on("stop_playing", () => this.stopManual());
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setCards(data) {
    this.setState((state) => ({ cards: [data, ...state.cards] }));
  }

  setDealCards(data) {
    this.setState((state) => ({ dealCards: [data, ...state.dealCards] }));
  }

  toggleCard(data) {
    let { cards } = this.state;

    for (var i = 0; i < cards.length; i++) {
      if (cards[i].pos === data.pos) {
        cards[i].hold = data.hold;
      }
    }
  }

  deal(data) {
    let { win, score } = data;
    let { engine, dealCards } = this.state;

    if (win !== 0) playAudio("win.mp3");
    else playAudio("lost.mp3");

    // Update Table
    engine.emit("update_table", score);

    engine.init = true;
    engine.dealCards = dealCards;
    engine.winning = win;
    engine.deal();
  }

  stopManual() {
    if (this._isMounted) {
      this.setState({ started: false, buttonText: "BET", disabled: false });
    }
  }

  error(data) {
    if (this._isMounted) {
      this.setState({ disabled: false });

      sendNotfication(data.message, "info", "top-center");

      if (data.code === "credit") this.props.setWallet(true, data.uid);
    }
  }

  play() {
    if (this._isMounted) {
      this.setState({ disabled: false, buttonText: "Deal", deal: true });
    }
  }

  busted() {
    if (this._isMounted) {
      this.setState({
        disabled: true,
        buttonText: "BET",
        deal: false,
        cards: [],
        dealCards: [],
      });
      wait(3000).then(() => {
        this.setState({ disabled: false });
      });
    }
  }

  placeBet() {
    if (this._isMounted) {
      let { engine, amount, deal, cards } = this.state;
      wait(100).then(() => {
        engine.init = true;
        engine.coin = this.props.coin;
        engine.amount = amount;
        engine.cards = cards;

        if (deal) {
          engine.emit(C.DEAL_VIDEOPOKER);
        } else {
          engine.start();
        }
      });
    }
  }

  isCorrectBet() {
    if (this._isMounted) {
      let { amount, isLogged } = this.state;

      // Check User
      if (!isLogged) {
        return Event.emit("showAuthModal", true);
      }

      if (amount.trim() === "") return false;

      if (!isValidNumber(amount)) return false;

      if (parseFloat(amount) <= 0) {
        this.setState({ amount: forceSatoshiFormat(50.00) });
      } else {
        amount = Math.min(
          parseFloat(storage.getKey("credit")),
          parseFloat(amount)
        );
        this.setState({ amount: forceSatoshiFormat(amount) });
      }
      return true;
    }
  }

  handleBet(e) {
    if (this._isMounted) {
      e.preventDefault();

      // Check is Correct Bet
      if (!this.isCorrectBet()) return false;

      this.setState({ disabled: true });
      this.placeBet();
    }
  }

  handleInputChange(event) {
    if (this._isMounted) {
      let target = event.target;
      let value = target.type === "checkbox" ? true : target.value;
      let name = target.name;

      if (__.isEmpty(value)) {
        if (name === "amount") this.setState({ bitError: "red-border" });
      } else {
        if (name === "amount") this.setState({ bitError: false });
      }

      if (name === "amount") {
        this.setState({ amount: value });
        if (!isValidNumber(value)) return;
      }

      if (name === "amount") {
        storage.setKey("lam", value);

        // Update Table
        this.state.engine.emit("update_table_amount", value);
      }

      this.setState({ [name]: value });
    }
  }

  handleMode = (value) => {
    if (this._isMounted) {
      this.setState({ type: value });
      let name;
      if (value === "1") name = "DEFAULT";
      if (value === "2") name = "HARD";
      this.setState({ typeName: name });
    }
  };

  setAmount = (val) => {
    if (this._isMounted) {
      var am = forceSatoshiFormat(val);
      this.setState({ amount: am });
      storage.setKey("lam", am);

      // Update Table
      this.state.engine.emit("update_table_amount", am);
    }
  };

  render() {
    let { disabled, typeName } = this.state;

    return (
      <>
        <form
          className="w-100 mt-1"
          onSubmit={(e) => {
            e.preventDefault();
            if (this.props.coin === "inr") {
              if (this.state.amount < 100) {
                sendNotfication("Enter valid amount");
              } else {
                this.handleBet(e);
              }
            } else if (this.props.coin === "inr") {
              if (this.state.amount < 1) {
                sendNotfication("Enter valid amount");
              } else {
                this.handleBet(e);
              }
            } else {
              this.handleBet(e);
            }
          }}
        >
          <Row>
            <div
              className="bet-option game-fonts"
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-around",
                padding: "2px 5px",
                textAlign: "center",
                alignItems: "center",
                justifyItems: "center",
                margin: "0px 4px",
              }}
            >
              {/* manual */}
              <div
                style={{
                  borderRadius: "2rem",
                  padding: "12px 45px",
                  backgroundColor: "#222328",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Manual
              </div>

              {/* auto */}
             
            </div>
            <Col xl={11} md={11} sm={11}>
              <div
                className={
                  "form-group mb-1 bet-input cashout " + this.state.bitError
                }
              >
                <div
                  style={{
                    color: "gray",
                    fontSize: "15px",
                    padding: "2px",
                    marginLeft: "12px",
                    justifyItems: "center",
                    alignItems: "center",
                  }}
                  className="game-fonts"
                >
                  Amount
                  <span
                    style={{
                      padding: "0px 3px",
                      color: "#3d9d0c",
                      fontSize: "15px", // Increase the icon size if needed
                      fontWeight: "bold", // Attempt to bolden icon by scaling
                      //   display: 'inline-flex',
                      alignItems: "center",
                    }}
                  >
                    <FiAlertCircle style={{ strokeWidth: 3 }} />{" "}
                    {/* Increase strokeWidth for a bolder look */}
                  </span>
                </div>
                <div className="input-group ">
                  <div className="input-radius-left">
                    <div className="input-group-append ">
                      <span
                        className="input-group-text "
                        style={{ backgroundColor: "#222328" }}
                      >
                        <img
                          src={"/assets/images/USDT.png"}
                          className={"mini-coin-7"}
                          alt=""
                        />
                        {/* BET */}
                      </span>
                    </div>
                  </div>
                  <input
                    style={{
                      borderRadius: "0 0px 0px 0", // Rounded right side of the input field
                      paddingLeft: "0px", // Optional: Ensure the padding inside the input is well spaced
                      backgroundColor: "#222328",
                    }}
                    type="text"
                    disabled={disabled}
                    className="form-control"
                    id="amount"
                    name="amount"
                    value={this.state.amount}
                    autoComplete={"off"}
                    onKeyUp={this.handleInputChange}
                    onChange={this.handleInputChange}
                  />
                  <div
                    className="input-group-append"
                    style={{ display: "flex", gap: "1px" }}
                  >
                    <div
                      className="game-fonts"
                      style={{
                        width: "40px",
                        display: "flex",
                        backgroundColor: "#31343c",
                        alignItems: "center",
                        textAlign: "center",
                        justifyItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      /2
                    </div>
                    <div
                      className="game-fonts"
                      style={{
                        width: "40px",
                        backgroundColor: "#31343c",
                        alignItems: "center",
                        textAlign: "center",
                        display: "flex",
                        justifyItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      x2
                    </div>
                    <RangeCredit set={this.setAmount} />
                  </div>
                </div>
              </div>
            </Col>
            <Col xl={11} md={11} sm={11}>
              <div className={"form-group mb-1  "}>
                <div className="input-group fw">
                  <div className="input-group-append input-radius-left">
                    <span
                      className="input-group-text game-fonts"
                      style={{ backgroundColor: "#222328" }}
                    >
                      TYPE
                    </span>
                  </div>
                  <Dropdown
                    className={
                      "drop-select btn-block game-fonts input-radius-right"
                    }
                    style={{
                      paddingLeft: "0px",
                      backgroundColor: "#222328",
                    }}
                  >
                    <Dropdown.Toggle
                      split
                      variant=""
                      className={"py-0 mt-0"}
                      style={{ textAlign: "left" }}
                    >
                      <span className=" game-fonts">
                        {typeName}
                        <i
                          className={"mdi mdi-chevron-down "}
                          style={{ textAlign: "" }}
                        />
                      </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      disabled={disabled}
                      className={"dopdown-menu-bottom  " + disabled}
                      style={{ backgroundColor: "#17181b" }}
                    >
                      <Dropdown.Item
                        onClick={(e) => this.handleMode("1")}
                        className={
                          "animated fadeIn dropdown-item-but game-fonts"
                        }
                      >
                        DEFAULT
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={(e) => this.handleMode("2")}
                        className={
                          "animated fadeIn dropdown-item-but game-fonts"
                        }
                      >
                        HARD
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </Col>
          </Row>
          <div>
            <span style={{ fontSize: 11, marginLeft: 10 }}>
              {this.props.coin === "inr"
                ? "(Minimum Bet - 100 USDT)"
                : "(Minimum Bet - 1 USDT)"}
            </span>
          </div>
          <Row>
            <Col md={11} sm={11} className="m-auto">
              <div className={"form-group rev mt-2 mb-0"}>
                <Button
                  variant={"btn btn-block btn-bet btn-xl"}
                  disabled={disabled}
                  type="submit"
                  style={{
                    // border: "2px solid red",
                    color: "#fff",
                    boxShadow:
                      "0px 0px 12px rgba(35, 238, 136, 0.3), 0px -2px #9fe871 inset",

                    // backgroundColor: "rgb(67, 179, 9)",
                    backgroundImage:
                      "linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113))",
                    borderRadius: "10px",
                  }}
                >
                  {this.state.buttonText}
                </Button>
              </div>
            </Col>
            <div
              className="mines-option game-fonts"
              style={{
                display: "flex",
                width: "100%",
                marginBottom: "0px",
                justifyContent: "space-around",
                padding: "2px 5px",
                textAlign: "center",
                alignItems: "center",
                justifyItems: "center",
                margin: "0px 5px",
                borderTop: "1px solid #222328",
              }}
            >
              {/* Manual */}
              <div className={`mines-manual-button `}>Manual</div>

              {/* Auto */}
             
            </div>
          </Row>
        </form>
      </>
    );
  }
}

Bet.propTypes = {
  coin: PropTypes.string,
  credit: PropTypes.string,
};

const mapStateToProps = (state) => ({
  coin: state.items.coin,
  credit: state.items.credit,
});

export default connect(mapStateToProps, { gameCoin, setWallet })(Bet);
